<template>
  <SessaoExpirada v-if="loaded"/>
</template>

<script>
import SessaoExpirada from './SessaoExpirada.vue';
export default {
  components: { SessaoExpirada },
  metaInfo: {
    title: 'Sessão expirada'
  },
  data () {
    return {
      loaded: false
    };
  },
  mounted () {
    if (localStorage.status && localStorage.status === 'loggedOut') {
      this.loaded = true
    }
  },
  computed: {
    color: function () {
      return this.$theme.dark ? '#0000007A' : '#FFFFFFCA';
    },
  },
};
</script>
